<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-card-label-component v-bind="$props" :class="evaluateClasses(classes)"></dr-card-label-component>
  </dr-wrapper>
  <dr-card-label-component v-else-if="isVisible" v-bind="$props" :class="evaluateClasses(classes)"></dr-card-label-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import drCardLabelComponent from './dr-card-label-component'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    drCardLabelComponent
  }
}
</script>

<style>

</style>